import {createSlice} from '@reduxjs/toolkit';
import type {RootState} from '../store';

interface MenuState {
    isOpen: boolean;
}

const initialState: MenuState = {
    isOpen: false,
};

export const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        open: (state) => {
            state.isOpen = true;
        },
        close: (state) => {
            state.isOpen = false;
        }
    },
});

export const {open, close} = menuSlice.actions;

export const selectIsOpen = (state: RootState) => state.menu.isOpen;

export default menuSlice.reducer;
